import _ from "lodash";
import MD5 from "crypto-js/md5";

export const MOBILE = 'm'
export const LARGE = 'l'

export const SCOPE_BROWSER = "B"
export const SCOPE_DEVICE_SIZE = "DS"
export const SCOPE_USER = "U"

const CONFIG_VERSION_KEY = "conf._meta.version";
export default class ConfigManager{

    constructor() {
        this.size = this.detectSize();
        this.preloadedFinished = false;
        this.otherSize = this.size == MOBILE ? LARGE : MOBILE;
    }

    detectSize() {
        let minDim = window.screen.height;
        if(window.screen.width < minDim){
            minDim = window.screen.width;
        }

        if(minDim <400 ){
            return MOBILE;
        }

        return LARGE;
    }

    /**
     * @param {String} key
     * @param {*} val
     * @param {String?} scope? SCOPE_BROWSER | SCOPE_DEVICE_SIZE | SCOPE_USER
     * @param {String} userId
     */
    async save(key, val, scope, userId = ""){
        key = this.makeKey(key, userId);
        if(scope === undefined){
            scope = SCOPE_USER;
        }
        if(scope == SCOPE_DEVICE_SIZE) {
            scope += "-" + this.size;
        }
        let encodedVal = JSON.stringify(val);
        localStorage.setItem("conf." + scope + ":" + key, encodedVal);

        let version = Date.now() + "-" + Math.random();
        localStorage.setItem(CONFIG_VERSION_KEY, version);
        return await Rpc.UserConfig.save("conf." + scope + ":" + key, encodedVal, version).then();
    }

    /**
     * @param {string} key
     * @param {*?} defaultVal
     * @return {*}
     */
    load(key, defaultVal){
        key = this.makeKey(key);
        const scopes = [SCOPE_BROWSER, SCOPE_DEVICE_SIZE + "-" + this.size, SCOPE_USER, SCOPE_DEVICE_SIZE + "-" + this.otherSize];
        for(let i in scopes){

            let encoded = localStorage.getItem("conf." + scopes[i] + ":" + key);
            if(encoded != null && encoded !== "null"){
                try {
                    return JSON.parse(encoded);
                } catch (e){
                    console.warn(e);
                    return defaultVal
                }
            }
        }

        return defaultVal;
    }

    makeKey(key, userIdTmp = ""){
        let userId = SessionManager?.applicationUser?.id ?? userIdTmp;
        userId = MD5(userId).toString();
        return userId + "-" + key;
    }

    delete(key, val, scope){
        key = this.makeKey(key);
        if(scope === undefined){
            scope = SCOPE_USER;
        }
        localStorage.removeItem("config." + scope + ":" + key);
        Rpc.UserConfig.delete("conf." + scope + ":" + key, version).then();
    }

    async preload(){
        const t0 = performance.now();

        /** @type {UserConfigEntry[]} */
        let conf = await Rpc.UserConfig.getUserConfig(localStorage.getItem(CONFIG_VERSION_KEY));
        if(conf === null){
            const t1 = performance.now()
            Log.info(`Loading config: no changes (${t1-t0}ms)`);
            this.preloadedFinished = true;
            return;
        }

        const configKeys = new Set();
        let refreshed = 0;
        conf.forEach(entry => {
           configKeys.add(entry.entryKey);
           refreshed++;
           localStorage.setItem(entry.entryKey, entry.entryValue);
        });

        let toRemove = [];
        for(let k in localStorage){
            if(k.startsWith("config.")){
                if(!configKeys.has(k)){
                    toRemove.push(k);
                }
            }
        }

        let deleted = 0;
        toRemove.forEach(k => {localStorage.removeItem(k); deleted++;});
        const t1 = performance.now()
        Log.info(`Loading config: ${deleted} keys deleted; ${refreshed} keys refreshed  (${t1-t0}ms)`);
        this.preloadedFinished = true;
    }
}


